import React from "react";

import { SOIL_PROPERTY_ORIGIN_LABEL, SOIL_PROPERTY_ORIGIN_STYLE, SoilPropertyOrigin } from "consts";

import { Flex, Tooltip } from "components";

const originTag = (origin: SoilPropertyOrigin) => (
  <Tooltip title={SOIL_PROPERTY_ORIGIN_LABEL[origin]} placement="top">
    <span style={{ ...SOIL_PROPERTY_ORIGIN_STYLE[origin], border: "none", fontSize: "10px" }}>{SOIL_PROPERTY_ORIGIN_LABEL[origin].at(0)}</span>
  </Tooltip>
);

// Single version: one origin. Comparison: baseline and candidate can be different major versions,
// so their origins for the same field can genuinely differ — show both rather than picking one.
export const SoilPropertyOriginTag = ({ origin, candidateOrigin }: { origin: SoilPropertyOrigin; candidateOrigin?: SoilPropertyOrigin }) => {
  if (candidateOrigin === undefined || candidateOrigin === origin) return originTag(origin);
  return (
    <span style={{ fontSize: "4px" }}>
      {originTag(origin)} {originTag(candidateOrigin)}
    </span>
  );
};

export const SoilPropertyOriginTagLegend = () => (
  <Flex vertical gap="0.75rem" style={{ border: "1px solid #ccc", padding: "1rem" }} align="center">
    This is describes the source of the values
    <Flex gap="0.75rem">
      {(Object.keys(SOIL_PROPERTY_ORIGIN_LABEL) as SoilPropertyOrigin[]).map((origin) => (
        <Flex key={origin} gap="0.25rem" align="center" style={{ ...SOIL_PROPERTY_ORIGIN_STYLE[origin], border: "none", fontSize: "10px" }}>
          <span style={{ ...SOIL_PROPERTY_ORIGIN_STYLE[origin] }}>{SOIL_PROPERTY_ORIGIN_LABEL[origin].at(0)}</span>
          <span style={{ ...SOIL_PROPERTY_ORIGIN_STYLE[origin] }}>=</span>
          <span style={{ ...SOIL_PROPERTY_ORIGIN_STYLE[origin] }}>{SOIL_PROPERTY_ORIGIN_LABEL[origin]}</span>
        </Flex>
      ))}
    </Flex>
  </Flex>
);
